module.exports = {"TXTCLI_Apply__forChanges":{"id":"TXTCLI_Apply__forChanges","defaultMessage":"Εφαρμογή","flags":["TRACK"],"track":"Apply"}}